import { dropCursor } from 'prosemirror-dropcursor';
import { gapCursor } from 'prosemirror-gapcursor';
import { history } from 'prosemirror-history';

import keys from './keys';
import { placeholderPlugin } from './placeholderPlugin';
import rules from './rules';

export default [
  rules,
  keys,
  placeholderPlugin,
  dropCursor(),
  gapCursor(),
  history(),
];
